import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BrandLogo } from "../../components/BrandLogo";
import { LayoutGrid, UtensilsCrossed, Clock, Bike, Receipt, LogOut } from "lucide-react";

const links = [
  { to: "/admin", icon: LayoutGrid, label: "Live Orders", end: true },
  { to: "/admin/menu", icon: UtensilsCrossed, label: "Menu" },
  { to: "/admin/hours", icon: Clock, label: "Hours" },
  { to: "/admin/delivery", icon: Bike, label: "Delivery" },
  { to: "/admin/history", icon: Receipt, label: "Orders" },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-brand-cream flex flex-col md:flex-row">
      {/* Sidebar (desktop/tablet) */}
      <aside className="hidden md:flex flex-col w-56 bg-brand-dark text-brand-cream p-4 shrink-0">
        <div className="px-2 py-3"><BrandLogo dark size="text-2xl" /></div>
        <nav className="mt-4 flex-1 space-y-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-3 rounded-xl font-semibold text-sm transition-colors ${isActive ? "bg-brand-teal text-white" : "text-brand-cream/60 hover:bg-white/5"}`}>
              <l.icon className="w-5 h-5" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="logout-btn" onClick={doLogout} className="flex items-center gap-3 px-3 py-3 rounded-xl text-brand-cream/60 hover:bg-white/5 text-sm font-semibold">
          <LogOut className="w-5 h-5" /> Sign out
        </button>
      </aside>

      {/* Top bar (mobile) */}
      <header className="md:hidden bg-brand-dark text-brand-cream px-4 py-3 flex items-center justify-between sticky top-0 z-30">
        <BrandLogo dark size="text-xl" />
        <button data-testid="logout-btn-mobile" onClick={doLogout}><LogOut className="w-5 h-5" /></button>
      </header>

      <main className="flex-1 min-w-0 pb-20 md:pb-0"><Outlet /></main>

      {/* Bottom nav (mobile) */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-brand-dark text-brand-cream flex justify-around py-2 z-30">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end}
            className={({ isActive }) => `flex flex-col items-center gap-0.5 px-2 py-1 text-[10px] font-semibold ${isActive ? "text-brand-teal-light" : "text-brand-cream/50"}`}>
            <l.icon className="w-5 h-5" /> {l.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
